import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RolepermissionService } from 'src/app/services/rolepermission.service';

@Component({
  standalone: false,
  selector: 'app-assign-modal-user-role',
  templateUrl: './assign-modal-user-role.component.html',
  styleUrls: ['./assign-modal-user-role.component.scss'],
})
export class AssignmodaluserroleComponent implements OnInit {
  @Input() finalSubmissionArray: any[];

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private rolepermissionService: RolepermissionService,
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
  ) {
  }

  ngOnInit(): void { }

  assignRoleToUser() {
    this.rolepermissionService
      .addUserRoleMappping(this.finalSubmissionArray[0])
      .subscribe((res) => {
        this.modalService.dismissAll();
        this.activeModal.dismiss();
        setTimeout(() => {
          window.location.reload();
        }, 5000);
        // this.router.navigate(['/role-permission/']);
      });
  }
}
